export default __webpack_public_path__ + "static/media/10607-dog-avatar-shock.f9c53f82.png";